export class ClinicalExamModel
{
patientcode = '' ;
examdate = '2024-01-01' ;
examlocation = '' ;
examperfstatus = '' ;
examnotes = '' ;
userid = '' ;
username = '' ;
examtime = '2024-01-01';
}
